/**
 * This file is replaced in the 'npm run build:version' script.
 */
export var RXDB_VERSION = '15.32.0';
